export default "__VITE_ASSET__MIWGM7EM__"